import React, { Component } from 'react';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import warningAlert from './warning-alert.png'
import FAQ from '../Inc/FAQ';
import { Input, Button, Modal, message, Row, Form, Col, Card, Spin, Icon, Tooltip } from 'antd';
import { compose } from 'recompose';
import Skeleton from 'react-loading-skeleton';
import SearchAlumniFilter from '../Inc/SearchAlumniFilter';
import { history } from '../../container/History';
const { TextArea } = Input;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const FormItem = Form.Item;
let notes = ''
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};
class ActivateMembershipForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            registrationid: 0,
            loading: false,
            MembershipName: '',
            notes: '',
            viewApplication: false,
            handleDenyModalVisible: false,
            acceptModalVisible: false,
            memberIdError: ""
        }
    }

    componentWillReceiveProps = (nextprops) => {
        if (this.props.registrationID !== nextprops.registrationID) {
            this.props.actions.getPendingMembershipRecord(nextprops.registrationID)
            this.props.actions.getPendingMembershipRecordPayment(nextprops.registrationID)
            this.props.actions.getRegistrationNotes(nextprops.registrationID)
            this.setState({
                registrationid: nextprops.registrationID,
                MembershipName: ''
            })
       }
    }

    componentDidMount = () => {
        if (this.props.registrationID) {
            this.props.actions.getPendingMembershipRecord(this.props.registrationID)
            this.props.actions.getPendingMembershipRecordPayment(this.props.registrationID)
            this.props.actions.getRegistrationNotes(this.props.registrationID)
            if (this.state.registrationid == 0) {
                this.setState({
                    registrationid: parseInt(this.props.registrationID),
                    MembershipName: ''
                })
            }
        }
        this.props.actions.getNESAmembershiplevels()
        this.props.actions.getSAFmembershiplevels()
        this.props.actions.getStates()
    }
    states = () => {
        if (this.props.allstates) {
            let statesarray = this.props.allstates
            return statesarray.map((k, index) => {
                return (
                    <option key={index} value={k.id}>{k.short}</option>
                )
            })
        }
    }

    addnotesvalue = (e) => {
        notes =  e.target.value
        this.setState({
            notes: e.target.value
        })
    }

    showApplcation = (value) => {
        this.setState({
            viewApplication: value
        })
    }

    updateNotes = () => {
        if (notes == '') {
            message.error('Note Field is Empty!', 3)
        } else {
            this.props.actions.membershipNotes(notes, this.state.registrationid, true)
        }
    }

    getMembershipName = (applicationType) => {
        if (this.props.nesa_levels && this.props.record && this.props.saflevels) {
            if (applicationType == "Alumni") {
                let saflevels = this.props.saflevels
                saflevels.map((k, index) => {
                    if (parseInt(k.id) === this.props.record.alumniMembershipLevelId) {
                        if (this.state.MembershipName == '') {
                            this.setState({
                                MembershipName: k.name
                            })
                        }
                    }
                })
            } else {
                let nesalevels = this.props.nesa_levels
                nesalevels.map((k, index) => {
                    if (parseInt(k.id) === this.props.record.alumniMembershipLevelId) {
                        if (this.state.MembershipName == '') {
                            this.setState({
                                MembershipName: k.name
                            })
                        }
                    }
                })
            }
        }
    }

    RenderRecords = () => {
        if (this.props.record && this.props.notes) {
            //if (this.props.record) {
            let notesArray = this.props.notes
            let recentNote = ""
            let noteIndex = notesArray.length - 1
            if (noteIndex != -1) {
                recentNote = notesArray[noteIndex].note
            }
            this.getMembershipName(this.props.record.applicationType)
            let shippingaddress = {}
            if (!this.props.record.parentGuardianInfo.shipToSelf) {
                shippingaddress.firstname = this.props.record.firstName
                shippingaddress.lastname = this.props.record.lastName
                shippingaddress.addline1 = this.props.record.addressLine1
                shippingaddress.addline2 = this.props.record.addressLine2
                shippingaddress.city = this.props.record.city
                shippingaddress.state = this.props.record.state
                shippingaddress.country = this.props.record.country
                shippingaddress.zipcode = this.props.record.zip
                shippingaddress.phone = this.props.record.phoneCountryId + this.props.record.areaCode + this.props.record.lineNumber
                shippingaddress.email = this.props.record.email
            } else {
                shippingaddress.firstname = this.props.record.parentGuardianInfo.firstName
                shippingaddress.lastname = this.props.record.parentGuardianInfo.lastName
                shippingaddress.addline1 = this.props.record.parentGuardianInfo.addressLine1
                shippingaddress.addline2 = this.props.record.parentGuardianInfo.addressLine2
                shippingaddress.city = this.props.record.parentGuardianInfo.city
                shippingaddress.state = this.props.record.parentGuardianInfo.state
                shippingaddress.country = this.props.record.parentGuardianInfo.country
                shippingaddress.zipcode = this.props.record.parentGuardianInfo.zip
                shippingaddress.phone = this.props.record.parentGuardianInfo.phoneCountryId + this.props.record.parentGuardianInfo.areaCode + this.props.record.parentGuardianInfo.lineNumber
                shippingaddress.email = this.props.record.parentGuardianInfo.email
            }
            const { getFieldDecorator } = this.props.form;
            return (
                <Row gutter={48} className="merbership-field-container">
                    {/* <Row type="flex" className='member-id-container' justify="center" align="bottom">
                        <Col span={24}>
                            <FormItem
                                label=""
                            >
                                {getFieldDecorator('member_id', {
                                    rules: [{ 
                                        required: true, 
                                        message: 'Enter Member ID!' 
                                    },
                                    {
                                        pattern: /^\d+$/,
                                        message: 'Member ID must contain only numbers.'
                                    }],
                                })(
                                    <Input placeholder="Member ID*" />
                                )}
                            </FormItem>
                        </Col>
                    </Row> */}
                    {this.state.viewApplication &&
                        <div>
                            <div className="membership-heading"><h4>MEMBERSHIP INFORMATION</h4><hr /></div>
                            <Row className="membeship-panel">
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'> Membership: </label>
                                        <label className='membership-field-value'>{this.state.MembershipName} </label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'> Amount Paid: </label>
                                        <label className='membership-field-value'> $ {this.props.record.totalAmountPaid} </label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'> Is Rush: </label>
                                        <label className='membership-field-value'>{this.props.record.isRush ? "YES" : "NO"} </label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'> TransactionID: </label>
                                        <label className='font-12 membership-field-value'>{this.props.paymentrecords ? this.props.paymentrecords.length != 0  ? this.props.paymentrecords[0].paymentTransactionId : "-" : '-'}  </label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'> Applicant ID: </label>
                                        <label className='membership-field-value'>{this.props.record.applicantId} </label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'> Application Date: </label>
                                        <label className='membership-field-value'>{this.props.record.applicationDate}</label>
                                    </Col>
                                </Row>
                            </Row>
                            <div className="membership-heading"><h4>ALUMNI INFORMATION</h4><hr /></div>
                            <Row className="membeship-panel">
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Member ID: </label>
                                        <label className='membership-field-value'>{this.props.record.memberId}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  First Name:  </label>
                                        <label className='membership-field-value'>{this.props.record.firstName}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Middle Name:  </label>
                                        <label className='membership-field-value'>{this.props.record.middleName}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Last Name:  </label>
                                        <label className='membership-field-value'>{this.props.record.lastName}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Date of Birth:  </label>
                                        <label className='membership-field-value'>{this.props.record.dateOfBirth}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Age:  </label>
                                        <label className='membership-field-value'>{this.props.record.age}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Gender:  </label>
                                        <label className='membership-field-value'>{this.props.record.gender}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Ethnic:  </label>
                                        <label className='membership-field-value'>{this.props.record.ethnicBackground}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Phone:  </label>
                                        <label className='membership-field-value'>{this.props.record.phoneCountryId + this.props.record.areaCode + this.props.record.lineNumber}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Email:  </label>
                                        <label className='membership-field-value'>{this.props.record.email}</label>
                                    </Col>
                                </Row>
                            </Row>
                            <div className="membership-heading"><h4>EAGLE INFORMATION</h4><hr /></div>
                            <Row className="membeship-panel">
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Board Review Date:  </label>
                                        <label className='membership-field-value'>{this.props.record.boardReviewDate}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Eagle Unit Number:  </label>
                                        <label className='membership-field-value'>{this.props.record.eagleUnitNumber}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Eagle Scout City:  </label>
                                        <label className='membership-field-value'>{this.props.record.eagleScoutCity}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Eagle Scout State:  </label>
                                        <label className='membership-field-value'>{this.props.record.eagleScoutState}</label>
                                    </Col>
                                </Row>
                            </Row>
                            <div className="membership-heading"><h4>SHIPPING INFORMATION</h4><hr /></div>
                            <Row className="membeship-panel">
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  First Name:  </label>
                                        <label className='membership-field-value'>{shippingaddress.firstname}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Last Name:  </label>
                                        <label className='membership-field-value'>{shippingaddress.lastname}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Address Line 1:  </label>
                                        <label className='membership-field-value'>{shippingaddress.addline1}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Address Line 2:  </label>
                                        <label className='membership-field-value'>{shippingaddress.addline2}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  City:  </label>
                                        <label className='membership-field-value'>{shippingaddress.city}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  State:  </label>
                                        <label className='membership-field-value'>{shippingaddress.state}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Country:  </label>
                                        <label className='membership-field-value'>{shippingaddress.country}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  ZIP Code:  </label>
                                        <label className='membership-field-value'>{shippingaddress.zipcode}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Phone:  </label>
                                        <label className='membership-field-value'>{shippingaddress.phone}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Email:  </label>
                                        <label className='membership-field-value'>{shippingaddress.email}</label>
                                    </Col>
                                </Row>
                            </Row>
                        </div>
                    }
                    {!this.state.viewApplication &&
                        <div>
                            <Row className="membeship-panel">
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'> Membership: </label>
                                        <label className='membership-field-value'>{this.state.MembershipName} </label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'> Amount Paid: </label>
                                        <label className='membership-field-value'> $ {this.props.record.totalAmountPaid} </label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'> Is Rush: </label>
                                        <label className='membership-field-value'>{this.props.record.isRush ? "YES" : "NO"} </label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'> TransactionID: </label>
                                        <label className='font-12 membership-field-value'>{this.props.paymentrecords ? this.props.paymentrecords.length != 0  ? this.props.paymentrecords[0].paymentTransactionId : "-" : '-'}  </label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'> Applicant ID: </label>
                                        <label className='membership-field-value'>{this.props.record.applicantId} </label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'> Application Date: </label>
                                        <label className='membership-field-value'>{this.props.record.applicationDate}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  First Name:  </label>
                                        <label className='membership-field-value'>{this.props.record.firstName}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Last Name:  </label>
                                        <label className='membership-field-value'>{this.props.record.lastName}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Date of Birth:  </label>
                                        <label className='membership-field-value'>{this.props.record.dateOfBirth}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Age:  </label>
                                        <label className='membership-field-value'>{this.props.record.age}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Gender:  </label>
                                        <label className='membership-field-value'>{this.props.record.gender}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Ethnic:  </label>
                                        <label className='membership-field-value'>{this.props.record.ethnicBackground}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Phone:  </label>
                                        <label className='membership-field-value'>{this.props.record.phoneCountryId + this.props.record.areaCode + this.props.record.lineNumber}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Email:  </label>
                                        <label className='membership-field-value'>{this.props.record.email}</label>
                                    </Col>
                                </Row>
                                <Row type='flex' align='middle'>
                                    <Col span={10}>
                                        <label className='membership-field-label'>  Board Review Date:  </label>
                                        <label className='membership-field-value'>{this.props.record.boardReviewDate}</label>
                                    </Col>
                                    <Col span={14}>
                                        <label className='membership-field-label'>  Eagle Unit Number:  </label>
                                        <label className='membership-field-value'>{this.props.record.eagleUnitNumber}</label>
                                    </Col>
                                </Row>
                            </Row>
                            <div className="membership-heading"><h4>NOTES</h4><hr /></div>
                            <Row type="flex" className='member-id-container' justify="center" align="bottom">
                                <Col span={24}>
                                    <FormItem
                                    >
                                        {getFieldDecorator('notes', {
                                            initialValue: recentNote ? recentNote : "",
                                            rules: [{ required: false }],
                                        })(
                                            <TextArea
                                                // value={recentNote}
                                                placeholder=""
                                                onChange={this.addnotesvalue}
                                                autosize={{ minRows: 4, maxRows: 6 }}
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                        </div>
                    }
                </Row >
            )
        }
        return <Row>
            <Col span={24}>
                <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Membership Information..." />
            </Col>
        </Row>
    }

    // handleAccept = e => {
    //     e.preventDefault();
    //     this.props.form.validateFields((err, values) => {
    //         if (!err) {
    //             this.props.actions.activateMembership(values, this.state.registrationid, this.props.record, this.props.pendingPerPageSize)
    //             //this.props.actions.enternotes(values, this.state.registrationid)
    //         }
    //     })
    // }

    handleAccept = () => {
        console.log(this.props.form.getFieldValue("member_id"));
        console.log(this.props.form.getFieldsError());
        this.props.form.validateFields(["member_id"], (err) => {

            if (err) return;

            this.confirmAccept({
                preventDefault: () => {}
            });

        });

    }

    confirmAccept = e => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            console.log(values);
console.log(values.notes);
            if (err) return;

            const activate = () => {
                return this.props.actions.activateMembership(
                    values,
                    this.state.registrationid,
                    this.props.record,
                    this.props.pendingPerPageSize
                )
                .then(status => {

                    Modal.success({
                        className: "ErrorModal",
                        title: "Success",
                        content: status.message,
                        onOk: () => {
                            this.props.actions.getProcessedMembership(1, this.props.pendingPerPageSize, '');

                            if (this.props.onMembershipProcessed) {
                                this.props.onMembershipProcessed();
                            }
                            
                        }
                    });

                })
                .catch(error => {

                    // Modal.error({
                    //     className: "ErrorModal",
                    //     title: `${error.errorCode || ""} ${error.message || "Error"}`.trim(),
                    //     content: error.errorDesc || "Please try again later.",

                    //     onOk: () => {
                    //         this.setState({
                    //             acceptModalVisible: true
                    //         });
                    //     }
                    // });

                    this.setState({
                        memberIdError: error.errorDesc || error.message || "Invalid Member ID"
                    });

                });
            };

            const note = values.notes && values.notes.trim() ? values.notes : "Status updated to Processed";
                this.props.actions
                    .membershipNotes(note, this.state.registrationid, false)
                    .then(() => {
                        return activate();
                    })
                    .catch(() => {});
        });
    };

    handleDeny = () => {
        this.setState({handleDenyModalVisible : true});
    }

    // denyMembershipAction = () => {
    //     this.props.actions.denyMembership(this.state.registrationid)
    //     this.setState({handleDenyModalVisible : false});
    // }

    denyMembershipAction = () => {
        const { registrationid } = this.state;

        const deny = () => {
            return this.props.actions.denyMembership(registrationid)
                .then((status) => {

                    this.setState({
                        handleDenyModalVisible: false
                    });

                    Modal.success({
                        className: "ErrorModal",
                        title: "Success",
                        content: status.message,
                        onOk: () => {
                            if (this.props.onMembershipDenied) {
                                this.props.onMembershipDenied();
                            }
                        }
                    });

                });
        };

        const note = notes && notes.trim() ? notes : "Status updated to Denied";
            this.props.actions.membershipNotes(note, registrationid, false)
            .then(() => {
                deny();
            })
            .catch(() => {
           });
    };

    CloseDenySecurityModal = () => {
        this.setState({handleDenyModalVisible : false});
    }

    gotoPending = () => {
        this.setState({ MembershipName: '' })
        history.push("/pending-membership")
    }

    openAcceptModal = () => {
        this.setState({
            acceptModalVisible: true,
            memberIdError: ""
        });
    }

    closeAcceptModal = () => {
        this.setState({
            acceptModalVisible: false,
            memberIdError: ""
        });

        this.props.form.resetFields(["member_id"]);
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                <Form {...formItemLayout} className="activate-form">
                    <Row type="flex" justify="center" align="center">
                        <Col className="" span={24}>
                            <div
                                className="centered"
                                style={{ width: 700 }}
                            >
                                <Spin spinning={this.state.loading} tip="Activating Membership...">
                                    {this.RenderRecords()}
                                </Spin>
                            </div>
                        </Col>
                    </Row>
                    {this.props.record &&
                        <Row className='membership-activate-panel' type='flex' align='middle' justify='space-between'>
                            <Col>
                                <FormItem>
                                    <Button 
                                    // loading={this.props.activation_loading} 
                                    disabled={this.props.activation_loading || this.props.denyApplication_loading} 
                                    type="default" onClick={() => this.state.viewApplication ? this.showApplcation(false) : this.showApplcation(true)}> {this.state.viewApplication ? "Back" : "View Application"}</Button>
                                </FormItem>
                            </Col>
                            <Col >
                                <FormItem>
                                    <Tooltip placement="top" title="Activate this Membership">
                                        {/* <Button loading={this.props.activation_loading} type='primary' value='accept' htmlType="submit"> Accept</Button> */}
                                        <Button
                                            // loading={this.props.activation_loading}
                                            type="primary"
                                            onClick={this.openAcceptModal}>
                                            Accept
                                        </Button>
                                    </Tooltip>
                                </FormItem>
                            </Col>
                            <Col >
                                <FormItem>
                                    <Tooltip placement="top" title="Deny this Membership">
                                        <Button loading={this.props.denyApplication_loading} className='danger' value='deny' onClick={() => this.handleDeny()}> Deny</Button>
                                    </Tooltip>
                                </FormItem>
                            </Col>
                            {!this.state.viewApplication &&
                                <Col >
                                    <FormItem>
                                        <Tooltip placement="top" title="Update Notes">
                                            <Button type='default' value='notes' 
                                            disabled={this.props.activation_loading || this.props.denyApplication_loading} 
                                            loading={this.props.notes_updating} onClick={() => this.updateNotes()}> Update Notes</Button>
                                        </Tooltip>
                                    </FormItem>
                                </Col>
                            }
                        </Row>
                    }
                </Form>

                <Modal
                centered
                className='DenyMembershipSecurityModal'
                visible={this.state.handleDenyModalVisible}
                closable={false}
                footer={[
                    <div className="DenyMembershipSecurityModalFooter" >
                        <div className="CancelDenyMembershipAction">
                          <Button key="back" className="CancelDenyMembershipModal" onClick={this.CloseDenySecurityModal}>
                            Cancel
                          </Button>  
                        </div>
      
                        <div className="DenyMembershipAction">                                                    
                            <Button key="submit" type="primary" className="DenyMembershipActionHandler" onClick={this.denyMembershipAction}>
                              Deny Membership
                            </Button>
                        </div>                  
                    </div>
                  ]}
                >
                    <div className='center'>
                        <div className='WarningAlert'>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className='DenyingConfirmMessage'>
                            Confirm Denying NESA membership
                        </div>
                    </div>
                </Modal>
                <Modal
                    centered
                    title="Accept Membership"
                    visible={this.state.acceptModalVisible}
                    onCancel={this.closeAcceptModal}
                    footer={[
                        <Button onClick={this.closeAcceptModal}>
                            Cancel
                        </Button>,
                        <Button
                            type="primary"
                            loading={this.props.activation_loading}
                            onClick={this.handleAccept}>
                            Yes
                        </Button>
                    ]}
                >

                <FormItem label="Member ID"validateStatus={this.state.memberIdError ? "error" : undefined} help={this.state.memberIdError || undefined}>
                    {getFieldDecorator("member_id", {
                        rules: [
                            {
                                required: true,
                                message: "Enter Member ID!"
                            },
                            {
                                pattern: /^\d+$/,
                                message: "Member ID must contain only numbers."
                            }
                        ]
                    })(
                        <Input
                            placeholder="Enter Member ID"
                            autoFocus
                            onChange={() => {
                                if (this.state.memberIdError) {
                                    this.setState({ memberIdError: "" });
                                }
                            }}
                        />
                    )}
                </FormItem>

                </Modal>
            </div>

        );
    }

}

function mapStateToProps(state) {
    return {
        loading: state.membershiptoactivatereducer.loading,
        record: state.membershiptoactivatereducer.record,
        activation_loading: state.activateMembershipreducer.loading,
        activation_status: state.activateMembershipreducer.status,
        denyApplication_loading: state.denyMembershipreducer.loading,
        denyApplication_status: state.denyMembershipreducer.status,
        allstates: state.allstatesreducer.states,
        nesa_levels_loading: state.nesalevelsreducer.loading,
        nesa_levels: state.nesalevelsreducer.levels,
        saflevels_loading: state.saflevelsreducer.loading,
        saflevels: state.saflevelsreducer.levels,
        paymentrecords: state.membershiptransactionreducer.record,
        notes: state.regnotesreducer.notes,
        notes_updating: state.updatemembershipnotesreducer.loading
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}

const ActivateMembership = Form.create()(ActivateMembershipForm);

export default connect(mapStateToProps, mapDispatchToProps)(ActivateMembership);


// WEBPACK FOOTER //
// ./src/components/Membership/ActivateMembership.js